<template>
  <div class="mall-video-player">
    <video :src="src | replaceUrlProtocol" :data-poster="poster" ref="player" playsinline></video>
  </div>
</template>

<script>
import Plyr from 'plyr/dist/plyr.mjs';
import 'plyr/src/sass/plyr.scss?no-px2rem';
import { trackElClickH5 } from '@changba/funny';

export default {
  name: 'MallVideoPlayer',

  props: {
    src: {
      type: String,
      default: ''
    },

    poster: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
    };
  },

  mounted() {
    this.player = new Plyr(this.$refs.player, {
      controls: ['play-large', 'play', 'progress'],
      iconUrl: '//res.cdn.changbaimg.com/-/45328fbd01e8be57/plyr.svg',
      blankVideo: '//res.cdn.changbaimg.com/-/a251e59b016e90e2/blank.mp4'
    });

    this.player.on('play', () => {
      trackElClickH5('视频播放器播放');
    });
    this.player.on('pause', () => {
      trackElClickH5('视频播放器暂停');
    });
  },

  methods: {
    stop() {
      this.player.stop();
    },

    play() {
      this.$nextTick(() => {
        this.player.play();
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.mall-video-player {
  width: 100%;
  height: 100%;

  video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  --plyr-range-track-height: 2px;
  --plyr-range-thumb-height: 7px;
  --plyr-range-fill-background: #ddd;
  --plyr-video-control-background-hover: rgba(0, 0, 0, 0.4);

  &::v-deep {
    // ios 10 必须要这个样式，否则看不到播放器
    .plyr--video {
      width: 100%;
      height: 100%;
    }

    .plyr__poster {
      background-size: cover;
    }
  }
}
</style>
